/**
 * Find search matches across messages without highlighting content
 * @param {Array} messages - Array of message objects
 * @param {String} searchTerm - Text to search for
 * @returns {Array} Array of message indices that match the search
 */
export const findSearchMatches = (messages, searchTerm) => {
  if (!searchTerm || !messages) return [];

  const results = [];
  const lowerCaseQuery = searchTerm.toLowerCase().trim();

  // Skip if empty search
  if (lowerCaseQuery.length === 0) return [];

  messages.forEach((msg, index) => {
    // Skip non-text content
    if (!msg.content || typeof msg.content !== 'string') {
      return;
    }

    // Skip base64 data
    if (msg.content.startsWith('data:')) {
      return;
    }

    // Check if message contains the query (exact match)
    if (msg.content.toLowerCase().indexOf(lowerCaseQuery) !== -1) {
      results.push(index);
    }
  });

  return results;
};

/**
 * Highlight text within message content with span/mark tags
 * @param {String} content - Message content text
 * @param {String} searchTerm - Text to highlight
 * @returns {String} HTML string with highlighted terms
 */
export const highlightText = (content, searchTerm) => {
  // Return original content if searchTerm is empty or too short
  if (!searchTerm || searchTerm.trim() === '' || searchTerm.length < 3 || !content) {
    return content;
  }

  // If content is not a string, return it as is
  if (typeof content !== 'string') return content;

  try {
    // Escape special regex characters in the search term
    const escapedSearchTerm = searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`(${escapedSearchTerm})`, 'gi');

    // Only proceed with highlighting if there's an actual match
    if (!content.toLowerCase().includes(searchTerm.toLowerCase())) {
      return content;
    }

    return content.replace(
      regex, 
      '<mark style="background-color: rgba(0, 108, 219, 1); color: inherit; padding: 0; margin: 0; border-radius: 2px;">$1</mark>'
    );
  } catch (error) {
    console.error('Error in highlighting:', error);
    return content;
  }
};

export default {
  findSearchMatches,
  highlightText
}; 